export const CUQ2OL_OPTIONS = [
  {
    key: 'incomodo',
    label: 'Quanto você se sentiu incomodado nos últimos 15 dias, com os seguintes sintomas?',
    questions: [
      {
        key: 'coceira',
        label: '1. Coceira:',
      },
      {
        key: 'placas_avermelhadas',
        label: '2. Placas avermelhadas:',
      },
      {
        key: 'olhos_inchados',
        label: '3. Olhos inchados:',
      },
      {
        key: 'labios_inchados',
        label: '4. Lábios inchados:',
      },
    ],
  },
  {
    key: 'dia_a_dia',
    label:
      'Você pode nos dizer quanto a urticária lhe atrapalhou, nos últimos 15 dias,nos seguintes momentos do seu dia a dia?',
    questions: [
      {
        key: 'trabalho',
        label: '5. Trabalho:',
      },
      {
        key: 'atividade_fisica',
        label: '6. Atividade Física:',
      },
      {
        key: 'sono',
        label: '7. Sono:',
      },
      {
        key: 'lazer',
        label: '8. Lazer:',
      },
      {
        key: 'relacionamentos_sociais',
        label: '9. Relacionamentos sociais (com parceiro(a), amigos e parentes):',
      },
    ],
  },
  {
    key: 'dificuldades_urticaria',
    label:
      'Através das seguintes perguntas gostariamos de aprofundar as dificuldades e os problemas que podem estar ligados à urticária (referentes aos últimos 15 dias)',
    questions: [
      {
        key: 'dificuldade_dormir',
        label: '10. Você tem dificuldade para dormir?',
      },
      {
        key: 'acorda_durante_noite',
        label: '11. Você acorda durante a noite?',
      },
      {
        key: 'cansado_durante_dia',
        label: '12. Durante o dia você se sente cansado(a) porque não dorme bem à noite?',
      },
      {
        key: 'dificuldade_concentrar',
        label: '13. Você tem dificuldade para se concentrar?',
      },
      {
        key: 'nervoso',
        label: '14. Você se sente nervoso(a)?',
      },
      {
        key: 'pra_baixo',
        label: '15. Você se sente prá baixo?',
      },
      {
        key: 'limitado_comida',
        label: '16. Você se sente limitado(a) na escolha da sua comida?',
      },
      {
        key: 'vergonha_lesoes',
        label: '17. Você fica com vergonha das lesões da urticária que aparecem no seu corpo?',
      },
      {
        key: 'vergonha_lugares_publicos',
        label: '18. Você fica com vergonha de frequentar lugares públicos?',
      },
      {
        key: 'cosmeticos',
        label:
          '19. É um problema para você usar determinados cosméticos (perfumes, cremes, loções, sabonetes e maquiagens)?',
      },
      {
        key: 'limitado_roupa',
        label: '20. Você se sente limitado(a) na escolha das suas roupas?',
      },
      {
        key: 'limitado_atividades_esportivas',
        label: '21. Suas atividades esportivas são limitadas por causa da urticária?',
      },
      {
        key: 'incomodo_efeito_colateral',
        label:
          '22. Você fica incomodado(a) com os efeitos colaterais causados pelos remédios usados no tratamento da urticária?',
      },
    ],
  },
]
